module.exports = __webpack_public_path__ + "img/A16_19920197-001.35d64456.jpg";